import { render, staticRenderFns } from "./ServiceTrashCan.vue?vue&type=template&id=478e111b&scoped=true&"
import script from "./ServiceTrashCan.vue?vue&type=script&lang=ts&"
export * from "./ServiceTrashCan.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTrashCan.vue?vue&type=style&index=0&id=478e111b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478e111b",
  null
  
)

export default component.exports